import awardConstants from '../../../utils/awardConstants';

const getAwardIncludes = (trophyRecipientCategory) => {
    const baseTeamIncludes = `${
        '&include=team.id' +
        '&include=team.franchiseId' +
        '&include=team.fullName' +
        '&include=team.placeName' +
        '&include=team.commonName' +
        '&include=team.triCode' +
        '&include=team.logos' +
        '&include=team.active' +
        '&include=team.league.abbreviation'
    }`;

    const playerIncludes = `${
        trophyRecipientCategory === awardConstants.PLAYER
            ? '&include=player.firstName' +
              '&include=player.lastName' +
              '&include=player.position' +
              '&include=player.id' +
              '&include=value' +
              baseTeamIncludes
            : ''
    }`;

    const coachIncludes = `${
        trophyRecipientCategory === awardConstants.HEAD_COACH
            ? '&include=coach.firstName' + '&include=coach.lastName' + '&include=coach.id' + baseTeamIncludes
            : ''
    }`;

    const teamIncludes = `${
        trophyRecipientCategory === awardConstants.TEAM
            ? baseTeamIncludes + '&include=coach.firstName' + '&include=coach.lastName' + '&include=coach.id'
            : ''
    }`;

    const otherIncludes = `${
        trophyRecipientCategory === awardConstants.OTHER || trophyRecipientCategory === awardConstants.GENERAL_MANAGER
            ? '&include=fullName'
            : ''
    }`;

    const gmIncludes = `${
        trophyRecipientCategory === awardConstants.GENERAL_MANAGER ? baseTeamIncludes + otherIncludes : ''
    }`;

    return (
        `&include=seasonId` +
        teamIncludes +
        coachIncludes +
        playerIncludes +
        gmIncludes +
        otherIncludes +
        `&include=status` +
        `&include=imageUrl` +
        `&include=isRookie` +
        `&include=summary` +
        `&include=playerImageUrl`
    );
};

const awardEndpoint = (award) =>
    `/site/api/award-details` +
    `?cayenneExp=trophyCategoryId=${award.trophyCategory.id} and trophyId=${award.id}` +
    getAwardIncludes(award.trophyCategory.trophyRecipientCategory) +
    `&sort=seasonId` +
    `&dir=DESC`;

export default {
    awardEndpoint,
    getAwardIncludes,
};
